import React, { Component } from "react";
import { IconButton, MenuItem } from "@material-ui/core";
import { Translation } from "react-i18next";
import Menu from "@material-ui/core/Menu";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { withRouter } from "react-router-dom";
import RecentPlaylistMenu, { createPlaylistObject, PlaylistItemTypes } from "./RecentPlaylistMenu";
import RecentCFMenu from "./RecentCFMenu";
import ContentMenu from "./ContentMenu";
import { _newMessage } from "../../messages/Utils";
import { contentRequestTypes, messageTypes } from "../../messages/Const";
import ClearanceButton from "../../../_clearance/components/wizardv2/ClearanceButton";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import { defaultGroups } from "redux/Types";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import ContentAlert from "../../ml-content-tracker/content-alert/ContentAlert";
import { ContentAlertType } from "../../ml-content-tracker/content-alert/Const";
import { canCreateClearanceForms, canEditClearanceForms } from "../../../util/CommonFunc";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PermittedContent from "_module/component/permitted-content/PermittedContent";

class ContextActions extends Component {
  canCreateCF = false;
  canRunCFWizard = false;
  constructor(props) {
    super();
    this.state = {
      anchorEl: null,
      openaddedit: false,
      ContentAlertDialogOpen: false,
    };

    const { user: { externalRefId: userId } } = props;
    this.canCreateCF = canCreateClearanceForms();
    this.canRunCFWizard = canEditClearanceForms(userId);
  }

  componentDidMount() {
    const {
      searchCFRecent,
      cf: {
        recent: { busy },
        recentList,
        recentQuery,
      },
    } = this.props;
    if (!busy && !recentList) searchCFRecent(recentQuery);
  }

  handleClick = (event) => {
    const {
      setContextActionState,
      focusItem,
      row
    } = this.props;
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
    focusItem(row);
    if (setContextActionState) setContextActionState(true);
  };

  handleClose = (event) => {
    const {
      setContextActionState
    } = this.props;
    if (event) event.stopPropagation();
    if (setContextActionState) setContextActionState(false);
    this.setState({ anchorEl: null });
  };

  handleAction = (event, action) => {
    const {
      setContextActionState
    } = this.props;
    if (setContextActionState) setContextActionState(false);
    event.stopPropagation();
    this.setState({ anchorEl: null });
    window.alert("Under Development");
    return;

    if (action) {
      const { postItemTrack, rowId } = this.props;
      postItemTrack(action, `${action} in progress ...`, [rowId]);
    }
  };

  onloadMessage = (e) => {
    e.stopPropagation();
    this.setState({ anchorEl: null });
    const {
      setContextActionState,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,

        }
      }
    } = this.props;

    if (setContextActionState) setContextActionState(false);

    const { editMessage, setEditMessageCB, row } = this.props;
    setEditMessageCB(null);
    editMessage(
      _newMessage(
        messageTypes.CONTENT,
        [
          {
            id: row.id,
            title: row[trackFields.trackTitle.id],
            artist: row[trackFields.performer.id],
            artwork: row[trackFields.prodArtworkUrl.id],
          },
        ],
        row[trackFields.trackTitle.id]
      )
    );
  };

  linkContentReq = (e) => {
    e.stopPropagation();
    this.setState({ anchorEl: null });
    const { setLinkwithContentRequest, setEditMessageCB, row } = this.props;
    setEditMessageCB(null);
    setLinkwithContentRequest({ data: row, type: contentRequestTypes.TRACK_INSTRUMENTAL })
  }

  canRestrictTracks = () => {
    const {
      orgRuntime: {
        runtime: {
          _mlContentAdmin,
          _mlContentCanManageRestricted,
        }
      }
    } = this.props;
    let canRestrict = _PermittedContent(
      [_mlContentAdmin, _mlContentCanManageRestricted],
      []
    )
      ? true
      : false;
    return canRestrict;
  };

  canArchiveTracks = () => {
    const {
      orgRuntime: {
        runtime: {
          _mlContentAdmin,
          _mlContentCanArchive,
        }
      }
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanArchive],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  isContentTeam = () => {
    const { user } = this.props;
    let isInContentTeam = false;
    if (user?.credentials?.orgs?.length > 0) {
      user.credentials.orgs.map((org) => {
        if (org.id === user?.credentials?.orgID && Array.isArray(org.groups)) {
          isInContentTeam = org.groups.findIndex((v) => v === defaultGroups.CONTENT_GROUP) !== -1;
        }
      });
    }
    return isInContentTeam;
  }

  handleOpenContentAlert = (event) => {
    this.setState({ ContentAlertDialogOpen: true });
  }

  handleCloseContentAlert = () => {
    this.setState({ ContentAlertDialogOpen: false, anchorEl: null });
  }


  render() {
    const {
      user,
      classes,
      playlist: {
        plrecentList,
        plrecentQuery,
        plrecent: { busy: plrecentBusy },
      },
      cf: {
        recentList: recentCFList,
        recentQuery: recentCFQuery,
        recent: { busy: cfrecentBusy },
      },
      setRecentCFQuery,
      searchCFRecent,
      loadEdittablePlaylist,
      setPlaylistTracks,
      setPlrecentQuery,
      showMessage,
      postItem,
      row,
      GetUpdateTrack,
      emptySession,
      copyTrack,
      RemoveTrack,
      CtagSave,
      focusItem,
      showAutoMessage,
      data,
      data: { selectedItems, items },
      playoutSessionSave,
      MLPostItem,
      playoutShowAutoMessage,
      checkAndCreateOpenPlayout,
      checkOpenPlayout,
      addTracksToPlayout,
      craeteAndPublishPlayoutTracks,
      sessionData,
      trackSearch,
      search,
      contentTrackEditItem,
      removeExplicitRule,
      sendInvalidTracks,
      showAutoMessageMainSearch,
      showHideTrack,
      contentAlert,
      orgRuntime,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _trackMusicOrigins: trackOrigins,
          _canCreateContentAlert,
          _contentRequest,
          _mlLicensing, 
          _mlLicensingCanCreate,
          _libraryCanHideUnhideTracks,
          _mlLibraries

        }
      },
      createTrackBulkEdit,
      bulkEditData
    } = this.props;

    const { anchorEl, ContentAlertDialogOpen } = this.state;
    return (
      <Translation>
        {(t, { i18n }) => (
          <>

            {ContentAlertDialogOpen &&
              <ContentAlert
                DialogOpen={ContentAlertDialogOpen}
                classes={classes}
                DialogClose={this.handleCloseContentAlert}
                type={ContentAlertType.TRACK}
                source={row}
                {...this.props}
              />}

            <IconButton
              aria-controls="action-menu"
              aria-label={`More actions for row ${items.findIndex(e => e.id == row.id) + 1}`}
              aria-haspopup="true"
              onClick={this.handleClick}
              title={`More actions for ${row.trackTitle}`}
              id={`context-${row.id}`}
            >

              <MoreHorizIcon />
            </IconButton>
            {Boolean(anchorEl) ? (
              <Menu
                className={classes.popMenuDark}
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{
                  horizontal: "left",
                  vertical: "bottom",
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >


                <RecentPlaylistMenu
                  showMessage={showMessage}
                  setPlrecentQuery={setPlrecentQuery}
                  plrecentQuery={plrecentQuery}
                  handleClose={this.handleClose}
                  setPlaylistTracks={setPlaylistTracks}
                  items={[createPlaylistObject(row.id, PlaylistItemTypes.track, row)]}
                  classes={classes}
                  busy={plrecentBusy}
                  plrecentList={plrecentList}
                  loadEdittablePlaylist={loadEdittablePlaylist}
                  searchId={row.searchId}
                  user={user}
                  orgRuntime={orgRuntime}
                />
                {/* <div className={classes.listOfPlaylist}></div> */}
                <hr />
                <ClearanceButton
                  propogateClose={() => {
                    this.handleClose();
                  }}
                  selectedItems={[row.id]}
                  id={`tracks-${row.id}`}
                  items={[row]}
                  hideCount
                  orgRuntime={orgRuntime}
                />

                {/* commented live copy cf as per the ML20-3990  */}
                {/* <ClearanceButton
                  propogateClose={() => {
                    this.handleClose();
                  }}
                  selectedItems={[row.id]}
                  items={[row]}
                  hideCount
                  liveCopy
                  liveCopyDisabled={
                    row[trackFields.musicOrigin.id] !==
                    trackOrigins.origincommercial.val
                  }
                  orgRuntime={orgRuntime}
                /> */}


                {this.canRunCFWizard && <RecentCFMenu
                  user={user}
                  items={[row]}
                  classes={classes}
                  busy={cfrecentBusy}
                  recentList={recentCFList}
                  recentQuery={recentCFQuery}
                  tracks={[row.id]}
                  loadRecent={searchCFRecent}
                  setRecentQuery={setRecentCFQuery}
                  handleClose={this.handleClose}
                  showMessage={showMessage}
                  setCFTracks={postItem}
                  removeHistory={this.props.removeHistory}
                  removeTrackSearchkHistory={this.props.removeTrackSearchkHistory}
                  removeTrackSearchkHistoryAll={this.props.removeTrackSearchkHistoryAll}
                  orgRuntime={orgRuntime}
                />}
                <hr />


                {/* <AddToPlayout
                    classes={classes}
                    tracks={[row.id]}
                    handleClose={this.handleClose}
                    showMessage={showMessage}
                    checkAndCreateOpenPlayout={checkAndCreateOpenPlayout}
                    props={this.props}
                    addTracksToPlayout={addTracksToPlayout}
                    checkOpenPlayout={checkOpenPlayout}
                    trackSearch={trackSearch}
                    showAutoMessage={playoutShowAutoMessage}
                    orgRuntime={orgRuntime}
                  /> */}

                {/* <PlayoutPopup
                    classes={classes}
                    row={row}
                    tracks={[row.id]}
                    handleClose={this.handleClose}
                    action={"MusicSearch"}
                    props={this.props}
                    craeteAndPublishPlayoutTracks={craeteAndPublishPlayoutTracks}
                    playoutShowAutoMessage={playoutShowAutoMessage}
                    sendInvalidTracks={sendInvalidTracks}
                    orgRuntime={orgRuntime}
                  /> */}
                {/* <div className={classes.listOfClearance}>  </div> */}
                {/* {this.isContentTeam() &&  */}
                {/* <PermittedContent modulePath={[_contentRequest]}>
                  <>
                    <hr />
                    <MenuItem
                      className={classes.contentMessage}
                      onClick={(e) => {
                        this.linkContentReq(e);
                      }}
                    >
                      <EmailOutlinedIcon className={classes.actionMenuIcon} />{" "}
                      Link with Content Request
                      <HelpWrap config={helpModules.TSRCMContentMessage} />
                    </MenuItem>
                  </>
                  </PermittedContent> */}
                {/* } */}
                {/* <PermittedContent modulePath={[_canCreateContentAlert]}>
                    <MenuItem
                      className={classes.contentAlert}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ ContentAlertDialogOpen: true });
                      }}
                      disabled={row?.contentAlert || false}
                    >
               
                      <FiAlertTriangle className={classes.actionMenuIcon} />{" "}
                      Content Alert
                    </MenuItem>
                  </PermittedContent> */}

                <ContentMenu
                  classes={classes}
                  busy={cfrecentBusy}
                  recentQuery={recentCFQuery}
                  data={data}
                  tracks={[row.id]}
                  loadRecent={searchCFRecent}
                  setRecentQuery={setRecentCFQuery}
                  handleClose={this.handleClose}
                  showMessage={showMessage}
                  setCFTracks={postItem}
                  GetUpdateTrack={GetUpdateTrack}
                  emptySession={emptySession}
                  copyTrack={copyTrack}
                  row={row}
                  CtagSave={CtagSave}
                  RemoveTrack={RemoveTrack}
                  MLPostItem={MLPostItem}
                  //selectedItems={selectedItems}
                  focusItem={focusItem}
                  showAutoMessage={showAutoMessage}
                  search={search}
                  contentTrackEditItem={contentTrackEditItem}
                  mainProps={this.props}
                  removeExplicitRule={removeExplicitRule}
                  showAutoMessageMainSearch={showAutoMessageMainSearch}
                  contentAlert={contentAlert}
                  orgRuntime={orgRuntime}
                  user={user}
                  createTrackBulkEdit={createTrackBulkEdit}
                  bulkEditData={bulkEditData}
                  showHideTrack={showHideTrack}
                />


                <HelpWrap id={`tracks-help-${row.id}`} textLabel="Help" config={helpModules.TSRCM} />                
                {/* <PermittedContent modulePath={[_mlLibraries,_libraryCanHideUnhideTracks]}>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    // this.setState({ ContentAlertDialogOpen: true });
                  }}
                  // disabled={row?.contentAlert || false}
                >

                  <VisibilityIcon className={classes.actionMenuIcon} />{" "}
                 Show
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    // this.setState({ ContentAlertDialogOpen: true });
                  }}
                  // disabled={row?.contentAlert || false}
                >

                  <VisibilityOffIcon className={classes.actionMenuIcon} />{" "}
                  Hide
                </MenuItem>
                </PermittedContent> */}
               
              </Menu>
            ) : null}
          </>
        )}
      </Translation>
    );
  }
}

export default withRouter(ContextActions);
